import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Avatar from "../../../assets/companypic.png";
import { FaGithub } from "react-icons/fa6";
import { IoLogoLinkedin } from "react-icons/io5";
import CompanyJobs from "./CompanyJobs";
import CompanyInsights from "./CompanyInsights";
import { jobsEndpoint } from "../../../constants";
function CompanyProfile() {
  const [state, setState] = useState("jobs");
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const token = localStorage.getItem("token")

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(jobsEndpoint+`companies/${id}/`,{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCompany(data);
      } catch (error) {
        console.error("Failed to fetch company data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!company) {
    return <div>Company not found</div>;
  }

  return (
    <div className="flex flex-col gap-5">
      <section className="w-full relative pb-36">
        <div className="w-full h-54 bg-linear-to-r from-sky-300 to-white"></div>
        <div className="absolute top-[170px]  sm:pl-10  flex sm:flex-row flex-col justify-between sm:items-start items-center w-full">
          <div className="flex  items-center justify-start w-full">
            <div className="flex justify-center items-center relative">
              <img
                src={company.logo || Avatar}
                alt=""
                className="md:w-44 md:h-44 sm:w-36 sm:h-36 max-[420px]:h-24 max-[420px]:w-24 h-36  w-36 "
              />
            </div>
            <div className="flex  justify-between items-center w-full">
              <div className=" flex justify-start flex-col gap-1">
                <p className=" text-[#181D27] md:text-2xl sm:text-lg text-sm  font-semibold">
                  {company.name}
                </p>
                <p className=" text-[#535862] md:text-lg sm:text-sm text-xs ">
                  {company.website}
                </p>
              </div>

              <div className="sm:flex hidden items-center gap-4">
    
                <button className="text-white bg-[#009C97] text-sm font-semibold rounded-lg px-4 py-1.5 cursor-pointer">
                  View profile
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* content */}
      <section className="flex flex-col gap-10">
        <div className="w-full flex items-center gap-6">
          <button
            className={` ${
              state === "jobs" ? "text-[#009C97] bg-[#F5FFFD]" : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("jobs")}
          >
            Jobs
          </button>
          <button
            className={` ${
              state === "company insights"
                ? "text-[#009C97] bg-[#F5FFFD]"
                : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("company insights")}
          >
            Company Insights
          </button>{" "}
      
        </div>

        <div>
          {state === "jobs" ? (
            <CompanyJobs jobs={company.jobs} />
          ) : state === "company insights" ? (
            <CompanyInsights insights={company} />
          ) : state === "mock interview" ? (
            "<CandidateEditEducation />"
          ) : null}
        </div>
      </section>
    </div>
  );
}

export default CompanyProfile;